// @flow

import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import ViewsIcon from '../Icons/icon-view-grey.svg'
import DurationIcon from '../Icons/icon-duration-grey.svg'
import LikeIcon from '../Icons/icon-like-grey.svg'
import Info from '../Icons/icon-info.svg'
import CommentIcon from '../Icons/icon-comment-grey.svg'
import { time } from '../timeutils'
import Loading from '../Icons/loading.gif'
import ReactTooltip from 'react-tooltip'
import './ContentList.css'

type Props = {
  data: Array,
  groupFilter: {
    alt: string
  },
  title: string,
  type: string,
  location: string,
  viewDetails: Function,
  alt: string
}

/**
  * @func getTotalViewsRef
  * @param {string} location
  * @returns {string}
*/
const getTotalViewsRef = (location: string): string => {
  if (location === 'Explore') {
    return 'totalViewsExplore'
  }

  return 'totalViews'
}

/**
  * Diplay for content list
  * @class
  * @extends Component
*/
class ContentList extends Component<Props> {
  constructor (props) {
    super(props)

    this.infoRef = React.createRef()
  }

  /** render function */
  render () {
    let firstIcon
    let secondIcon
    let firstRef
    let secondRef

    const totalViewsRef = getTotalViewsRef(this.props.location)

    switch (this.props.type) {
      case 'ViewsDuration':
        firstIcon = ViewsIcon
        firstRef = totalViewsRef
        secondIcon = DurationIcon
        secondRef = 'avgViewDuration'
        break
      case 'Duration':
        firstIcon = DurationIcon
        firstRef = 'avgViewDuration'
        secondIcon = false
        secondRef = false
        break
      case 'Views':
        firstIcon = ViewsIcon
        firstRef = totalViewsRef
        secondIcon = false
        secondRef = false
        break
      case 'Comments':
        firstIcon = CommentIcon
        firstRef = 'totalComments'
        secondIcon = false
        secondRef = false
        break
      case 'Likes':
        firstIcon = LikeIcon
        firstRef = 'totalLikes'
        secondIcon = false
        secondRef = false
        break
      default:
        break
    }

    if (this.props.groupFilter.alt === 'Mobile' && this.props.type !== 'Social' && totalViewsRef === 'totalViews') { firstRef = firstRef + 'Mobile' }
    if (this.props.groupFilter.alt === 'Web' && this.props.type !== 'Social' && totalViewsRef === 'totalViews') { firstRef = firstRef + 'Web' }

    const content = this.props.data.map((entry) => {
      if (entry.title === 'Loading') {
        return (<table key={Math.random()}><tbody><tr><td><img src={Loading} alt='Loading' /></td></tr></tbody></table>)
      } else if (this.props.alt === 'IndUserView') {
        if (entry[firstRef] === 0) return null
        return (
          <div key='details' className='ContentDisplay details'>
            <img src={entry.smallThumbnailUrl} alt='' className='thumbnail' />
            <div>
              <p>{entry.title}</p>
              <span className='firstStat stat'><img src={firstIcon} alt={firstRef} />{entry[firstRef].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
              {secondIcon === DurationIcon ? <span className='stat'><img src={secondIcon} alt={secondRef} />{time(entry[secondRef])}</span> : ''}
            </div>
          </div>
        )
      } else if (entry.title.indexOf('DELETED') !== -1) {
        if (entry[firstRef] === 0 || !entry[firstRef]) return null
        return (
          <div className='ContentDisplay details' key={entry._id}>
            <img src={entry.smallThumbnailUrl} alt='' className='thumbnail' />
            <div>
              <p>{entry.title.replace('DELETED', '')} <i>(DELETED)</i></p>
              <span className='firstStat stat'><img src={firstIcon} alt={firstRef} />{entry[firstRef].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
              {secondIcon === DurationIcon ? <span className='stat'><img src={secondIcon} alt={secondRef} />{time(entry[secondRef])}</span> : ''}
            </div>
          </div>
        )
      } else {
        if (entry[firstRef] === 0 || entry[firstRef] === undefined) return null
        return (
          <Link key={entry._id} to={{ pathname: '/content', search: '?id=' + entry._id + '&date=Week&filter=__' }}>
            <div className='ContentDisplay details'>
              <img src={entry.smallThumbnailUrl} alt='' className='thumbnail' />
              <div>
                <p>{entry.title}</p>
                <span className='firstStat stat'><img src={firstIcon} alt={firstRef} />{entry[firstRef].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                { secondIcon === DurationIcon ? <span><img src={secondIcon} alt={secondRef} /> {time(entry[secondRef])}</span> : ''}
              </div>
              { entry.created && this.props.alt === 'AdminDetails' ? <span className='contentDate'>{entry.created}</span> : ''}
            </div>
          </Link>
        )
      }
    })

    if (this.props.alt === 'AdminDetails' || this.props.alt === 'IndUserView') {
      return (
        <div className='ContentList box'>
          <div>
            <h4 className='flex align-center space-between'>
              {this.props.title}
              <div className='info-box'>
                <img ref={this.infoRef} data-tip='* Deleted items will not display information past this page.' src={Info} alt={Info} className='info-icon' onMouseOver={() => { ReactTooltip.show(this.infoRef.current) }} />
                <ReactTooltip />
              </div>
            </h4>
          </div>
          {content}
        </div>
      )
    } else {
      if (this.props.location === 'News Feed') {
        return (
          <div className='ContentList box'>
            <div>
              <h4 className='flex align-center space-between'>
                {this.props.title}
                <div className='info-box-newsfeed'>
                  <img ref={this.infoRef} data-tip='* Deleted items will not display information past this page.' src={Info} alt={Info} className='info-icon-newsfeed' onMouseOver={() => { ReactTooltip.show(this.infoRef.current) }} />
                  <ReactTooltip />
                </div>
                <button onClick={() => this.props.viewDetails()}>View All</button>
              </h4>
            </div>
            {content}
          </div>
        )
      } else {
        return (
          <div className='ContentList box'>
            <div>
              <h4 className='flex align-center space-between'>
                {this.props.title}
                <div className='info-box'>
                  <img ref={this.infoRef} data-tip='* Deleted items will not display information past this page.' src={Info} alt={Info} className='info-icon' onMouseOver={() => { ReactTooltip.show(this.infoRef.current) }} />
                  <ReactTooltip />
                </div>
                <button onClick={() => this.props.viewDetails()}>View All</button>
              </h4>
            </div>
            {content}
          </div>
        )
      }
    }
  }
}

export default ContentList
